<ion-content [fullscreen]="true" class="content-login">
  <div class="login" [class.vista-movil]="esResolucionMovil">
    <div class="panel-informacion">
      <img
        src="assets/img/logo-blanco-2.svg"
        alt="Logo Unifersa"
        class="logo-titulo"
      />

      <h2>El marketplace <br> de Unifersa</h2>

      <div class="lista-caracteristicas">
        <span>Toda la información de los proveedores <br> de Unifersa en un único lugar.</span>
        <span>Consulta catálogos completos, tarifas, <br> datos de contacto y condiciones comerciales.</span>
        <span>Envía la propuesta de pedido directamente <br> al proveedor y recibe su presupuesto.</span>
      </div>
    </div>
    <div class="content-login">
      @if (restablecerContrasena) {
        <app-restablecer-contrasena
          (VolverInicio)="onVolverAtras()"
        >
        </app-restablecer-contrasena>
      }
      @else if (accederFactor2FA) {
        <app-inicio-factor
          (VolverInicio)="onVolverAtras()"
          [correo]="correoEmitido"
          [clave]="claveEmitida"
        >
        </app-inicio-factor>
      }
      @else if (acceder) {
        <app-acceso
          (RestablecerContrasena)="onRestablecerContrasena()"
          (Acceso2FA)="onAcceso2FA($event)"
        >
        </app-acceso>
      }
    </div>
  </div>
</ion-content>
